// Suggested walkthrough of the synthetic Class B lifecycle (first-slice-spec.md, "Demo
// walkthrough data", with the RS-and-OM role model of 0016_rs_replaces_aa_om_role.sql). Pure data;
// relative imports only (tests/unit/shell-home.test.ts).

export type WalkthroughStep = {
  /** Who acts, as shown to the user. */
  who: string
  /** Persona codes that take this step (empty: anyone, or the system). */
  personas: readonly string[]
  text: string
}

export const WALKTHROUGH: readonly WalkthroughStep[] = [
  {
    who: 'PA Ahmed',
    personas: ['PA'],
    text: 'Drafts the permit and submits it. To try it today, use the urgent route: ask to start sooner than the notice period and give the reason. The RS must accept the urgency at the review.',
  },
  { who: 'OAC Hassan', personas: ['OAC'], text: 'Agrees to the work on behalf of the neighbouring OTSG area.' },
  { who: 'PA Ahmed', personas: ['PA'], text: 'Records the method statement.' },
  { who: 'RS Khalid', personas: ['RS'], text: 'Verifies the method statement, records the permit meeting review and authorises the permit.' },
  {
    who: 'OM Sultan',
    personas: ['OM'],
    text: 'Approves the authorised permit as Operations Manager: the independent second check. No cycle can be requested until then.',
  },
  { who: 'PA Ahmed', personas: ['PA'], text: "Requests the day's cycle." },
  { who: 'RS Khalid', personas: ['RS'], text: 'Pre-issues the cycle.' },
  { who: 'AGT Omar', personas: ['AGT'], text: 'Tests the gas and signs the result.' },
  {
    who: 'RS Salim',
    personas: ['RS2'],
    text: 'Validates the cycle as a second RS: the 16 checks and the first-day worksite visit. (RS Khalid could validate it too, as a separate signature.)',
  },
  { who: 'PH Fatma', personas: ['PH'], text: 'Gives the toolbox talk.' },
  { who: 'Crew Ali and Maryam', personas: ['CREW1', 'CREW2'], text: 'Each signs, on their own sign-in, that they understood the talk.' },
  { who: 'PH Fatma', personas: ['PH'], text: 'Accepts the cycle. The server then checks whether work may proceed.' },
  { who: 'Anyone', personas: [], text: 'Reports a stop. Work must not proceed from that moment.' },
  { who: 'PH Fatma, then RS Salim', personas: ['PH', 'RS2'], text: 'The PH declares the site safe; the RS confirms the suspension.' },
  { who: 'PA, PH or RS', personas: ['PA', 'PH', 'RS', 'RS2'], text: 'Requests a new cycle. The daily steps are repeated before work restarts.' },
  { who: 'PH Fatma', personas: ['PH'], text: 'Cancels the permit when the work ends.' },
  { who: 'RS Salim', personas: ['RS2'], text: 'Inspects the worksite and closes the permit out.' },
  { who: 'System', personas: [], text: 'Archives the signed record.' },
]

/** Example inputs for the walkthrough permit (same data as the database tests). */
export const WALKTHROUGH_DATA: readonly [string, string][] = [
  ['Site and area', 'Adam Test Site (synthetic) - Water treatment unit (synthetic)'],
  ['Task', 'Surface Preparation: hand-tool cleaning (wire brush and scraper), no power tools, on pipe supports SYN-PS-101 to SYN-PS-103'],
  ['Procedure', 'SYN-MS-0001 Rev A, issued by Synthetic BadrEOR (demo)'],
  ['Supporting document', 'Method statement SYN-MS-0001 Rev A, verified by the RS'],
  ['Gas plan', 'Required: toxic gas or vapour may be present; test O2, LEL and H2S'],
  ['Affected area', 'Steam generation (OTSG) unit (synthetic): agreement by Synthetic Hassan Al-Yahyai'],
  ['Permit Holder and crew', 'Synthetic Fatma Al-Hinai; Synthetic Ali Al-Abri and Synthetic Maryam Al-Lawati'],
]
